import { FormEventHandler } from 'react'
import { Role } from '../../shared/types'
import { Button } from '../components/button'
import { Input } from '../components/input'
import { Switch } from '../components/switch'

type Props = {
	data?: Role
	onSubmit: FormEventHandler
	isPending?: boolean
}

export function AccountRolesForm({ data, onSubmit, isPending }: Props) {
	return (
		<form
			className="m-auto max-w-[60em] bg-white rounded-xl border border-slate-200"
			onSubmit={onSubmit}
		>
			<div className="flex items-center justify-between gap-4 px-3 py-3 sm:px-5 sm:py-4">
				<h3 className="text-md font-bold">{data ? 'Editace role' : 'Nová role'}</h3>
			</div>
			<div className="px-3 py-3 sm:px-5 sm:py-4 space-y-4 grid grid-cols-2 gap-4">
				<Input
					label="Název"
					name="name"
					maxLength={255}
					isRequired
					className="col-span-2"
					defaultValue={data?.name}
				/>
				<h4 className="col-span-2 font-bold">Rezervace</h4>
				<Switch
					label="Upravit"
					name="editReservations"
					value="1"
					defaultSelected={data?.editReservations}
				/>
				<Switch
					label="Potvrdit"
					name="confirmReservations"
					value="1"
					defaultSelected={data?.confirmReservations}
				/>
				<Switch
					label="Zrušit"
					name="cancelReservations"
					value="1"
					defaultSelected={data?.cancelReservations}
				/>
				<h4 className="col-span-2 font-bold">Dokumenty</h4>
				<Switch
					label="Upravit"
					name="addDocuments"
					value="1"
					defaultSelected={data?.addDocuments}
				/>
				<Switch
					label="Potvrdit"
					name="editDocuments"
					value="1"
					defaultSelected={data?.editDocuments}
				/>
				<Switch
					label="Zrušit"
					name="deleteDocuments"
					value="1"
					defaultSelected={data?.deleteDocuments}
				/>
				<h4 className="col-span-2 font-bold">Uživatelé</h4>
				<Switch label="Přidat" name="addUsers" value="1" defaultSelected={data?.addUsers} />
				<Switch
					label="Smazat"
					name="deleteUsers"
					value="1"
					defaultSelected={data?.deleteUsers}
				/>
				<Switch
					label="Upravit"
					name="editUsers"
					value="1"
					defaultSelected={data?.editUsers}
				/>
				<Switch
					label="Měnit roli"
					name="editUserRoles"
					value="1"
					defaultSelected={data?.editUserRoles}
				/>
				<h4 className="col-span-2 font-bold">Role</h4>
				<Switch
					label="Přidat"
					name="addAccountRoles"
					value="1"
					defaultSelected={data?.addAccountRoles}
				/>
				<Switch
					label="Smazat"
					name="deleteAccountRoles"
					value="1"
					defaultSelected={data?.deleteAccountRoles}
				/>
				<Switch
					label="Upravit"
					name="editAccountRoles"
					value="1"
					defaultSelected={data?.editAccountRoles}
				/>
				<h4 className="col-span-2 font-bold">Vozidla</h4>
				<Switch
					label="Přidat"
					name="addVehicles"
					value="1"
					defaultSelected={data?.addVehicles}
				/>
				<Switch
					label="Smazat"
					name="deleteVehicles"
					value="1"
					defaultSelected={data?.deleteVehicles}
				/>
				<Switch
					label="Upravit"
					name="editVehicles"
					value="1"
					defaultSelected={data?.editVehicles}
				/>
				<h4 className="col-span-2 font-bold">Vlastnosti objektů</h4>
				<Switch
					label="Přidat"
					name="addObjectProperties"
					value="1"
					defaultSelected={data?.addObjectProperties}
				/>
				<Switch
					label="Smazat"
					name="deleteObjectProperties"
					value="1"
					defaultSelected={data?.deleteObjectProperties}
				/>
				<Switch
					label="Upravit"
					name="editObjectProperties"
					value="1"
					defaultSelected={data?.editObjectProperties}
				/>
				<h4 className="col-span-2 font-bold">Pohledy</h4>
				<Switch
					label="Přidat"
					name="addDashboardViews"
					value="1"
					defaultSelected={data?.addDashboardViews}
				/>
				<Switch
					label="Smazat"
					name="deleteDashboardViews"
					value="1"
					defaultSelected={data?.deleteDashboardViews}
				/>
				<Switch
					label="Upravit"
					name="editDashboardViews"
					value="1"
					defaultSelected={data?.editDashboardViews}
				/>
				<h4 className="col-span-2 font-bold">Pobočky</h4>
				<Switch
					label="Přidat"
					name="addLocations"
					value="1"
					defaultSelected={data?.addLocations}
				/>
				<Switch
					label="Smazat"
					name="deleteLocations"
					value="1"
					defaultSelected={data?.deleteLocations}
				/>
				<Switch
					label="Upravit"
					name="editLocations"
					value="1"
					defaultSelected={data?.editLocations}
				/>
				<h4 className="col-span-2 font-bold">Pronajímatelé</h4>
				<Switch
					label="Přidat"
					name="addBrands"
					value="1"
					defaultSelected={data?.addBrands}
				/>
				<Switch
					label="Smazat"
					name="deleteBrands"
					value="1"
					defaultSelected={data?.deleteBrands}
				/>
				<Switch
					label="Upravit"
					name="editBrands"
					value="1"
					defaultSelected={data?.editBrands}
				/>
				<h4 className="col-span-2 font-bold">Přijaté příjmy</h4>
				<Switch
					label="Přidat"
					name="addPayments"
					value="1"
					defaultSelected={data?.addPayments}
				/>
				<Switch
					label="Smazat"
					name="deletePayments"
					value="1"
					defaultSelected={data?.deletePayments}
				/>
				<Switch
					label="Upravit"
					name="editPayments"
					value="1"
					defaultSelected={data?.editPayments}
				/>
				<h4 className="col-span-2 font-bold">Plánované příjmy</h4>
				<Switch
					label="Přidat"
					name="addExpenses"
					value="1"
					defaultSelected={data?.addExpenses}
				/>
				<Switch
					label="Smazat"
					name="deleteExpenses"
					value="1"
					defaultSelected={data?.deleteExpenses}
				/>
				<Switch
					label="Upravit"
					name="editExpenses"
					value="1"
					defaultSelected={data?.editExpenses}
				/>
				<h4 className="col-span-2 font-bold">Rozložení</h4>
				<Switch
					label="Přidat"
					name="addLayouts"
					value="1"
					defaultSelected={data?.addLayouts}
				/>
				<Switch
					label="Smazat"
					name="deleteLayouts"
					value="1"
					defaultSelected={data?.deleteLayouts}
				/>
				<Switch
					label="Upravit"
					name="editLayouts"
					value="1"
					defaultSelected={data?.editLayouts}
				/>
				<h4 className="col-span-2 font-bold">Statistiky</h4>
				<Switch
					label="Přístup"
					name="reporting"
					value="1"
					defaultSelected={data?.reporting}
				/>
				<h4 className="col-span-2 font-bold">Poptávky</h4>
				<Switch
					label="Přidat"
					name="addProposals"
					value="1"
					defaultSelected={data?.addProposals}
				/>
				<Switch
					label="Smazat"
					name="deleteProposals"
					value="1"
					defaultSelected={data?.deleteProposals}
				/>
				<Switch
					label="Upravit"
					name="editProposals"
					value="1"
					defaultSelected={data?.editProposals}
				/>
			</div>
			<Button type="submit" isPending={isPending} isDisabled={isPending}>
				Uložit
			</Button>
		</form>
	)
}
